import { chunk } from 'lodash';
import i18next from 'i18next';
import moment from 'moment-timezone';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import { generateDefaultSheet } from '@commons/utils/makeXLS';
import { getUserTimezone } from '@commons/utils/date';

import formatProductOrders from './format';
import getColumns from './columns';

const MAX_SHEET_ELEMENT_SIZE = 50_000;

export default (productOrders, { storeName, isCentralExport, currency }) => {
  const formattedProductOrders = formatProductOrders(productOrders);

  const shouldDisplayCustomerCode = formattedProductOrders.some(({ customerCode }) => customerCode);
  const shouldDisplayPackagingWeight = formattedProductOrders.some(
    ({ totPackagingWeight }) => totPackagingWeight,
  );

  const columns = getColumns({
    storeName,
    isCentral: isCentralExport,
    displayCustomerCode: shouldDisplayCustomerCode,
    displayPackagingWeight: shouldDisplayPackagingWeight,
  });

  const filename = i18next.t('ORDERS.ORDERS.CONTENT_EXPORT_TITLE_ORDER');
  const sheetName = i18next.t('ORDERS.ORDERS.LIST_EXPORT_SHEET_NAME_ORDER_PLURAL');

  const date = moment.tz(getUserTimezone()).format(DATE_DISPLAY_FORMATS.DASHED_YEAR_MONTH_DAY);
  const batchProductOrders = chunk(formattedProductOrders, MAX_SHEET_ELEMENT_SIZE);
  const hasManyFiles = batchProductOrders.length > 1;

  return batchProductOrders.map((chunkProductOrders, index) => {
    const appendFileCount = hasManyFiles ? `-${index + 1}` : '';
    const sheet = generateDefaultSheet(sheetName, columns, chunkProductOrders, currency);

    return {
      filename: `${filename}-${date}${appendFileCount}`,
      sheets: [sheet],
    };
  });
};
